export const createExposeCurrentFrameAndCurrentTime = (window) => {
    return (nativeContext, fn) => {
        Object.defineProperties(window, {
            currentFrame: {
                configurable: true,
                get() {
                    return Math.round(nativeContext.currentTime * nativeContext.sampleRate);
                }
            },
            currentTime: {
                configurable: true,
                get() {
                    return nativeContext.currentTime;
                }
            }
        });
        try {
            return fn();
        }
        finally {
            if (window !== null) {
                delete window.currentFrame;
                delete window.currentTime;
            }
        }
    };
};
//# sourceMappingURL=/build/es2018/factories/expose-current-frame-and-current-time.js.map